'use client';

import classNames from 'classnames';
import IconTile from '@alltrails/denali/components/IconTile';
import CheckSm from '@alltrails/denali/icons/CheckSm';
import type Tag from '@alltrails/types/Tag';
import styles from './PlanYourVisit.module.scss';
import icons from './tagIconMapping';

type GroupTagProps = {
  tag: Tag;
  isLightBackground: boolean;
  className?: string;
};

const GroupTag = ({ tag, isLightBackground, className }: GroupTagProps) => {
  const Icon = icons[tag.uid] || CheckSm;
  return (
    <div className={classNames(styles.tag, className)}>
      <IconTile emphasis={isLightBackground ? 'weak' : 'base'} icon={{ Component: Icon }} radius="circle" />
      <div className={styles.tagName}>{tag.name}</div>
    </div>
  );
};

export default GroupTag;
